import { ActivityLevelService } from "@/clients/services/ActivityLevelService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetActivityLevel = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKeys.ACTIVITY_LEVEL],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await ActivityLevelService.getActivityLevelApiV1ActivityLevelGet(
          user.id,
        );
      return data;
    },
  });

  return {
    activityLevel: data,
    isLoading,
    error,
  };
};
